import React from 'react';
import PropTypes from 'prop-types';
import Headline from '@components/atoms/headline/headline';
import MixedCopy from '@components/molecules/mixed-copy/mixedCopy';
import EducationNumber from '@components/atoms/education/number/educationNumber';
import FilterTag from '@components/atoms/filter-tag/filterTag';
import Container from '@components/layout/container/container';
import StyledEducationTabletStage from './educationTabletStage.style';

function EducationTabletStage({ number, headline, introCopy, educationTopics, educationType }) {
  return (
    <StyledEducationTabletStage>
      <Container>
        <div className="tablet-stage">
          {number && (
            <div className="tablet-stage__number-container">
              <EducationNumber
                className="tablet-stage__number"
                contentType={educationType}
                category={educationTopics}
                number={number}
              />
            </div>
          )}
          <div className="tablet-stage__content">
            {number === 1 && (
              <FilterTag inverted small className="tablet-stage__tag">
                Starting Point
              </FilterTag>
            )}
            {headline && (
              <Headline primary className="tablet-stage__headline">
                {headline}
              </Headline>
            )}
            {introCopy && <MixedCopy html={introCopy} fullWidth />}
          </div>
        </div>
      </Container>
    </StyledEducationTabletStage>
  );
}

EducationTabletStage.propTypes = {
  number: PropTypes.number.isRequired,
  headline: PropTypes.string.isRequired,
  introCopy: PropTypes.string,
  educationTopics: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  educationType: PropTypes.arrayOf(PropTypes.shape()).isRequired
};

export default EducationTabletStage;
